export const getInvertedStyle = (
  props,
  isDragging,
  isDropAnimating,
  isDraggingOver,
) => {
  const style = props?.style;
  if (isDropAnimating) return { ...style, transitionDuration: "0.001s" };
  if (isDragging) return style;
  if (!isDraggingOver) return style;
  if (style?.transform) return { ...style, transform: "translate(0px, 0px)" };

  const el = document.getElementById("HubScheduler-isDragging");
  if (!el) return style;
  const { height } = el.getBoundingClientRect();
  if (!height) return style;
  return { ...style, transform: `translate(0px, ${-height}px)` };
};

export const computePlaceholder = (update) => {
  if (!update?.destination) return null;

  const { droppableId, index } = update.destination;
  const container = document.querySelector(
    `[data-rbd-droppable-id='${droppableId}']`,
  );
  const target = container?.querySelector(`.HubDroppable-box-${index}`);
  const dragged = document.querySelector(
    `[data-rbd-draggable-id='${update.draggableId}']`,
  );
  if (!dragged) return null;

  const { clientHeight, clientWidth } = dragged;
  let clientY = 0;
  if (target) {
    const parentRect = target.parentNode.getBoundingClientRect();
    const itemRect = target.getBoundingClientRect();
    clientY = itemRect.top - parentRect.top - clientHeight;
  }

  return { clientHeight, clientWidth, clientY, destinationId: droppableId };
};
